import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export const getCommonStyles = (theme: Theme) =>
  StyleSheet.create({
    absolute: {
      position: 'absolute',
    },
    absoluteBottom: {
      position: 'absolute',
      bottom: 0,
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: theme.spacing.sm
    },
    rowNoGap: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    rowGapLg: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: theme.spacing.lg
    },
    rowBetween: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    gapSm: {
      gap: theme.spacing.sm
    },
    gapMd: {
      gap: theme.spacing.md
    },
    gapXxxl: {
      gap: theme.spacing.xxxl
    },
    flex: {
      flex: 1
    },
    flex315: {
      flex: 1,
      maxWidth: 315,
    },
    flex315Bordered: {
      flex: 1,
      height: '100%',
      maxWidth: 315,
      borderRightWidth: 1,
      borderRightColor: theme.colors.grey20,
    },
    flex370Bordered: {
      flex: 1,
      height: '100%',
      maxWidth: 370,
      borderRightWidth: 1,
      borderRightColor: theme.colors.grey20,
    },
    flex400Bordered: {
      flex: 1,
      height: '100%',
      maxWidth: 400,
      borderRightWidth: 1,
      borderRightColor: theme.colors.grey20,
    },
    flex300: {
      flex: 1,
      maxWidth: 300,
      borderLeftWidth: 2,
      borderLeftColor: theme.colors.primary,
    },
    flex350: {
      flex: 1,
      maxWidth: 350,
      borderLeftWidth: 2,
      borderLeftColor: theme.colors.primary,
    },
    flex400: {
      flex: 1,
      maxWidth: 400,
      borderLeftWidth: 2,
      borderLeftColor: theme.colors.primary,
    },
    flexCenter: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center'
    },
    flexMaxAuth: {
      flex: 1,
      maxWidth: 600
    },
    searchContainerMaxWidth: {
      maxWidth: 315,
      paddingRight: 0,
    },
    alignStart: {
      alignItems: 'flex-start'
    },
    alignEnd: {
      alignItems: 'flex-end'
    },
    alignSelfCenter: {
      alignSelf: 'center'
    },
    alignSelfEnd: {
      alignSelf: 'flex-end'
    },
    paddingHorizontal: {
      paddingHorizontal: theme.spacing.lg
    },
    paddingTop: {
      paddingTop: theme.spacing.md
    },
    paddingBottom: {
      paddingBottom: theme.spacing.md
    },
    paddingRight: {
      paddingRight: theme.spacing.lg
    },
    noPaddingTop: {
      paddingTop: 0
    },
    center: {
      justifyContent: 'center'
    },
    shadow: {
      shadowColor: "#000",
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.1,
      shadowRadius: 6,
      elevation: 5,
    },
    fullHeight: {
      height: '100%'
    },
    searchContainerNonMobile: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: theme.spacing.lg,
      paddingTop: theme.spacing.md,
    },
    searchContainerNonMobileWithoutPaddingLeft: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingRight: theme.spacing.lg,
      paddingTop: theme.spacing.md,
    },
    searchContainerNonMobileWithoutPaddingTop: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: theme.spacing.lg,
    },
});